// NOTE: process.env will be replaced by actual object by Webpack
// NOTE: not all variables will be compiled, but those starting with REACT_APP_ should be there
const ENV = process.env;

const CTAG = '[ENV]';
const CTAG2 = '[INIT-RELATED]';

const logI = /**@type VariadicV*/ console.info.bind(console, '[I]', CTAG, CTAG2); // eslint-disable-line no-console,no-unused-vars

logI('ENV:', ENV);

// noinspection JSUnusedGlobalSymbols
export default ENV;
